<template>
  <div>
    <el-row>
      <el-col>
        <el-alert
          title="Solo los archivos PDF pueden ser visualizados, los demás solo podrán ser descargados. El departamento de desarrollo trabajará con eso próximamente."
          type="info"
          center
          show-icon
          effect="dark"
        ></el-alert>
      </el-col>
    </el-row>
    <rabbey-toolbox
      :call-new="callNew"
      :filterables="true"
      @filter-search="filterSearch"
    />
    <el-row>
      <el-col>
        <rabbey-table3
          ref="table"
          :loading="loading"
          :data="items"
          :columns="columns"
          :actions="actions"
          @rtable-push-action="actionHandler"
        />
      </el-col>
    </el-row>

    <el-drawer
      :title="title"
      :visible.sync="legal_visible"
      direction="rtl"
      size="29%"
    >
      <div class="" style="padding: 20px">
        <div id="div-legal">
          <NewCategories
            class="scrollable"
            style="max-height: 800px"
            :Visible="legal_visible"
            ref="myCategories"
            @dialog-closed="newCategorieHandler"
            @refresh-table="refreshCategorieTable"
          ></NewCategories>
        </div>
      </div>
    </el-drawer>

    <!-- TABLA DEL DRAWER -->
    <rabbey-base-drawer :drawer.sync="drawer" size="70%" :title="drawerTitle">
      <rabbey-table3
        ref="table"
        :loading="drawerLoading"
        :data="drawerItems"
        :columns="drawerColumns"
        :actions="drawerActions"
        border
        stripe
        @rtable-push-action="drawerActionHandler"
      />
    </rabbey-base-drawer>

    <!-- DRAWER QUE ABRE EL DOCUMENTO PDF -->
    <rabbey-base-drawer
      :drawer.sync="documentDrawer"
      :before-close="resetVariables"
      size="85%"
    >
      <div class="embed-responsive embed-responsive-16by9">
        <iframe
          class="embed-responsive-item"
          width="100%"
          height="800px"
          :src="fileUrl"
          title="Documento Adjunto"
          allowfullscreen
        >
          ></iframe
        >
      </div>
    </rabbey-base-drawer>
  </div>
</template>

<script>
//import DeleteISOCategories from "@/components/functionals/DeleteISOCategories.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import NewCategories from "@/views/modules/iso/categories/NewCategories.vue";

//import ImagePerson from "../components/functionals/ImagePerson.vue";

export default {
  name: "ISOCategories",
  components: {
    NewCategories
  },
  created() {
    this.getTableData();
  },
  data() {
    return {
      items: [],
      loading: false,
      legal_visible: false,
      title: "",
      search: "",
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver Archivos",
          command: "view"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar Categoría",
          command: "delete"
        }
      ],
      columns: [
        {
          prop: "Name",
          label: "Nombre de Categoría",
          sortable: true
        },
        {
          prop: "ISODocumentMasterList",
          label: "Lista Maestra",
          sortable: true,
          formatter: (row) => {
            return row.ISODocumentMasterList.Name;
          }
        },
        {
          prop: "ISODocumentProcess",
          label: "Tipo de proceso",
          sortable: true,
          formatter: (row) => {
            return row.ISODocumentProcess.Name;
          }
        },
        {
          prop: "Origin",
          label: "Origin",
          sortable: true,
          formatter: (row) => {
            if (row.Origin == 0) return "Internos";
            if (row.Origin == 1) return "Externos";
          }
        },
        {
          prop: "ShouldBeRevisedBy",
          label: "Revisado Por",
          sortable: true,
          formatter: (row) => {
            return row.ShouldBeRevisedBy.FullName;
          }
        },
        {
          prop: "ShouldBeApprovedBy",
          label: "Aprovado Por",
          sortable: true,
          formatter: (row) => {
            return row.ShouldBeApprovedBy.FullName;
          }
        }
        // {
        //   prop: "Id",
        //   label: "Borrar",
        //   width: 100,
        //   sortable: false,
        //   formatter: DeleteISOCategories
        // }
      ],
      dialogVisible: false,
      documentId: 0,

      //Drawer files properties
      drawerTitle: "",
      drawer: false,
      drawerLoading: false,
      drawerItems: [],
      drawerColumns: [
        {
          prop: "DocumentCode",
          label: "Código",
          sortable: true,
          width: 140,
          fixed: true
        },
        {
          prop: "DocumentCategory.Name",
          label: "Nombre de documento",
          width: 250,
          sortable: true,
          formatter: (row) => {
            return row.DocumentCategory.Name;
          }
        },
        {
          prop: "DocumentCategory",
          label: "Tipo de documento",
          sortable: true,
          width: 170,
          formatter: (row) => {
            if (row.DocumentCategory.DocumentType == 0) return "Formulario";
            if (row.DocumentCategory.DocumentType == 1) return "Procedimiento";
            if (row.DocumentCategory.DocumentType == 2)
              return "Instrucciones de trabajo";
            if (row.DocumentCategory.DocumentType == 3) return "Normativas";
            if (row.DocumentCategory.DocumentType == 4) return "Documento";
          }
        },
        {
          prop: "DocumentCategory.ProcessNumber",
          label: "No. Versión",
          width: 150,
          sortable: true,
          formatter: (row) => {
            return row.DocumentCategory.ProcessNumber;
          }
        },
        {
          prop: "ISODocumentMasterList",
          label: "Lista Maestra",
          width: 150,
          sortable: true,
          formatter: (row) => {
            return row.ISODocumentMasterList.Name;
          }
        },
        {
          prop: "ISODocumentProcess",
          label: "Tipo de proceso",
          sortable: true,
          width: 250,
          formatter: (row) => {
            return row.ISODocumentProcess.Name;
          }
        },
        {
          prop: "Status",
          label: "Status",
          sortable: true,
          width: 150,
          formatter: (row) => {
            if (row.Status == 0) return "Nuevo";
            if (row.Status == 1) return "En Modificacion";
            if (row.Status == 2) return "En Proceso";
            if (row.Status == 3) return "Aprobado";
            if (row.Status == 4) return "Obsoleto";
          }
        },
        {
          prop: "CreatedAt",
          label: "Fecha de creacion",
          sortable: true,
          width: 160,
          formatter: DatetimeFormatter
        }
      ],
      drawerActions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        }
      ],
      fileUrl: "",
      documentDrawer: false,
      confirmationIcon: "",
      confirmationQuestion: "",
      downloadFile: "",
      isPDF: false,
      documentName: ""
    };
  },
  methods: {
    newCategorieHandler() {
      this.legal_visible = false;
    },
    refreshCategorieTable() {
      this.legal_visible = false;
      this.getTableData();
    },
    getTableData(options) {
      if (!options) {
        options = {};
      }
      this.loading = true;
      this.$http
        .get("/api/ISODocumentCategory", {
          params: {
            "criteria.CompanyCode": this.currentCompany,
            "criteria.Search": this.search
          }
        })
        .then((response) => {
          const {
            data: { Items, ItemCount, CurrentPage }
          } = response;

          this.items = Items;
          this.currentPage = CurrentPage;
          this.totalItems = ItemCount;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => (this.loading = false));
    },
    filterSearch(searchKey) {
      this.search = searchKey;
      this.getTableData({ Search: searchKey });
    },
    //METODO QUE MANEJA LOS ACTIONS DE LA TABLA DE LAS CATEGORÍAS
    actionHandler(action) {
      switch (action.command) {
        case "view": {
          this.drawerTitle = `Archivos con clasificación: ${action.row.Name}`;
          this.drawer = true;
          this.drawerLoading = true;
          this.getDrawerTableData(action.row.Id);
          break;
        }
        case "delete": {
          this.confirmationQuestion =
            "¿Seguro que quiere eliminar la categoría?";
          this.confirmationIcon = "error";
          this.documentId = action.row.Id;
          this.confirmationAction();
          break;
        }
      }
    },
    //METODO QUE MANEJA LA CONFIRMACIÓN DE LA DESCARGA DE ARCHIVO O ELIMINACIÓN DE CATEGORÍA.
    confirmationAction() {
      this.$confirm(this.confirmationQuestion, "Confirmación", {
        confirmButtonText: "Si",
        cancelButtonText: "Cancel",
        type: this.confirmationIcon,
        center: true
      })
        .then(() => {
          if (this.documentName) {
            this.drawerViewFile(this.documentName);
          } else if (this.documentId) {
            this.deleteDocument(this.documentId);
          }
          this.resetVariables();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Proceso cancelado"
          });
          this.resetVariables();
        });
    },
    resetVariables() {
      (this.fileUrl = ""), (this.documentId = 0), (this.documentDrawer = false);
    },
    callNew() {
      this.title = "Nueva categoría de documento";
      this.legal_visible = true;
    },
    deleteDocument(fileId) {
      this.$http
        .delete("/api/ISODocumentCategory/Delete", {
          params: {
            id: fileId
          }
        })
        .then((response) => {
          if (response.statusText == "OK") {
            let deletedFileId = this.items.findIndex(
              (item) => item.Id == fileId
            ); //getting the id of the clicked item for deletion
            this.items.splice(deletedFileId, 1);
            this.$message({
              type: "success",
              message: "Categoría eliminada exitosamente"
            });
          } else {
            this.$message({
              type: "error",
              message: "Error al eliminar el documento"
            });
          }
        });

      this.dialogVisible = false;
    },
    //METODO PARA CONSEGUIR LOS DATOS DE LA TABLA DEL DRAWER
    getDrawerTableData(categoryId) {
      this.$http
        .get("/api/ISODocuments/", {
          params: {
            "criteria.CompanyCode": this.currentCompany,
            "criteria.Page": this.currentPage,
            "criteria.Limit": this.pageSize,
            "criteria.DocumentsByCategory": true,
            "criteria.DocumentCategoryId": categoryId
          }
        })
        .then((response) => {
          this.drawerItems = response.data.Items;
          this.drawerLoading = false;
          if (this.drawerItems.length == 0) {
            this.$message({
              type: "error",
              message: "Esta categoría no tiene docuementos asociados a esta"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //METODO PARA MANEJAR EL ACTION DE VER DOCUMENTO Y CONFIRMACIÓN DE DESCARGA EN TABLA DEL DRAWER
    drawerActionHandler(action) {
      switch (action.command) {
        case "view": {
          this.documentName = action.row.DocumentURL;
          var file = this.documentName;
          if (file.substr(file.length - 4) != ".pdf") {
            this.confirmationQuestion =
              "Este archivo no es PDF, solo los archivos PDF pueden ser visualizados. ¿Quisiera descargar el archivo?";
            this.confirmationIcon = "info";
            this.isPDF = false;
            this.confirmationAction();
          } else {
            this.isPDF = true;
            this.drawerViewFile(file);
            this.documentDrawer = true;
          }
        }
      }
    },
    //METODO PARA ABRIR EL ARCHIVO
    drawerViewFile(documentName) {
      this.$http
        .get("/api/ISODocuments/OpenFile", {
          params: {
            documentName: documentName
          }
        })
        .then((response) => {
          if (this.isPDF) {
            this.fileUrl = response.data;
          } else {
            this.downloadFile = response.data;
          }
        })
        .finally(() => {
          if (!this.isPDF) {
            let link = document.createElement("a");
            link.href = this.downloadFile;
            link.download = "download";
            link.click();
            this.fileUrl = "";
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
